import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  // address: [],
  loading: false,
  addBtnLoading: false,
  removeBtnLoading: false,
  userAddress: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_NEW_ADDRESS:
      return updateObject(state, action.payload);
    case actionTypes.REMOVE_ADDRESS:
      return updateObject(state, action.payload);
    case actionTypes.FETCH_ADDRESS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;